import { SET_USER_DETAILS } from '../store/Constants'

const initialState = {
	userDetails: {},
}

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_USER_DETAILS:
			return {
				...state,
				userDetails: action.payload,
			}
		default:
			return state
	}
}

export default reducer
